// src/components/portfolio/add-asset/services/PositionService.js
import { collection, getDocs } from 'firebase/firestore';
import { db, auth } from '../../../../services/firebase/config';

export class PositionService {
  // Kullanılan sembolleri bul
  static getUsedSymbols(portfolioData) {
    const symbols = new Set();
    
    const traverse = (data) => {
      if (!data) return;
      
      // Ana kategorileri kontrol et
      Object.values(data).forEach(category => {
        // Assets varsa ekle
        if (category.assets) {
          Object.keys(category.assets).forEach(symbol => symbols.add(symbol));
        }
        
        // Alt kategorileri kontrol et
        if (category.subCategories) {
          Object.values(category.subCategories).forEach(subCategory => {
            if (subCategory.assets) {
              Object.keys(subCategory.assets).forEach(symbol => symbols.add(symbol));
            }
          });
        }
      });
    };

    traverse(portfolioData);
    return Array.from(symbols);
  }

  // Aktif portföyün pozisyonlarını getir (kullanılmayan)
  static async searchPositions(portfolioId, portfolioData = {}) {
    try {
      if (!portfolioId || !auth.currentUser?.email) return [];

      const positionsRef = collection(db, 
        'users', 
        auth.currentUser.email,
        'portfolios',
        portfolioId,
        'positions'
      );

      const snapshot = await getDocs(positionsRef);
      
      // Mevcut portföyde kullanılan sembolleri bul
      const usedSymbols = this.getUsedSymbols(portfolioData);
      
      // Sadece kullanılmayan pozisyonları getir
      const availablePositions = snapshot.docs
        .map(doc => {
          const data = doc.data();
          return {
            symbol: doc.id,
            name: data.description || doc.id,
            type: 'STOCK',
            exchangeShortName: 'BIST',
            info: {
              lastPrice: data.lastPrice,
              quantity: data.quantity,
              value: data.value,
              cost: data.cost
            }
          };
        })
        // Portföyde kullanılmayan pozisyonları filtrele
        .filter(position => !usedSymbols.includes(position.symbol));

      return availablePositions;

    } catch (error) {
      console.error('Error in PositionService:', error);
      return [];
    }
  }
}